xtensionsClientWebpackJsonp([3],{

/***/ 1199:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1200);


/***/ }),

/***/ 1200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_connector__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_platform_browser_dynamic__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_core__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PromiseWrapper__ = __webpack_require__(280);





__webpack_require__(284);
if (__webpack_require__(283).production) {
    Object(__WEBPACK_IMPORTED_MODULE_3__angular_core__["_21" /* enableProdMode */])();
}
var connectorProps = window.xprops;
if (connectorProps) {
    connectorProps.getAccessTokenAsync = Object(__WEBPACK_IMPORTED_MODULE_4__utils_PromiseWrapper__["a" /* PromiseWrapper */])(connectorProps.getAccessTokenAsync);
    var providers = [
        { provide: __WEBPACK_IMPORTED_MODULE_1__app_connector__["b" /* ConnectorExternalProps */], useValue: connectorProps },
        { provide: __WEBPACK_IMPORTED_MODULE_1__app_connector__["a" /* CommonExternalProps */], useValue: connectorProps },
    ];
    Object(__WEBPACK_IMPORTED_MODULE_2__angular_platform_browser_dynamic__["a" /* platformBrowserDynamic */])(providers)
        .bootstrapModule(__WEBPACK_IMPORTED_MODULE_1__app_connector__["c" /* ConnectorModule */]);
}
else {
    throw new Error("xprops is not found");
}
//# sourceMappingURL=../../src/xcomponents/connector/index.js.map

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_xcomponent_dist_xcomponent__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_xcomponent_dist_xcomponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_xcomponent_dist_xcomponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_getComponentCurrentScript__ = __webpack_require__(89);


var componentCurrentScript = Object(__WEBPACK_IMPORTED_MODULE_1__utils_getComponentCurrentScript__["a" /* getComponentCurrentScript */])(['connectorComponent.bundle.js', 'connector.bundle.js']);
window.NtxConnector = __WEBPACK_IMPORTED_MODULE_0_xcomponent_dist_xcomponent___default.a.create({
    // The html tag used to render my component
    tag: 'nintex-connector',
    // The url that will be loaded in the iframe or popup, when someone includes my component on their page
    url: componentCurrentScript.src.replace(/[^\/]+$/, 'connector.html'),
    // A bridge to allow IE to send messeges to child window via an Iframe
    bridgeUrl: componentCurrentScript.src.replace(/[^\/]+$/, 'cross-window-bridge.html'),
    // The size of the component on their page
    dimensions: {
        width: '800px',
        height: '600px'
    },
    contexts: {
        popup: true
    },
    defaultLogLevel: 'warn',
    // The properties they can (or must) pass down to my component
    props: {
        getAccessTokenAsync: {
            type: 'function',
            required: true
        },
        selectedAppId: {
            type: 'string',
            required: false
        },
        selectedConnectionId: {
            type: 'string',
            required: false
        },
        onSuccess: {
            type: 'function',
            required: true
        },
        onFailure: {
            type: 'function',
            required: true
        },
        theme: {
            type: 'object',
            required: false
        },
        langs: {
            type: 'string',
            required: false
        },
        isAiXtensionsBuilderEnabled: {
            type: 'boolean',
            required: false
        },
    }
});
//# sourceMappingURL=../../src/xcomponents/connector/definition.js.map

/***/ })

},[1199]);


// WEBPACK FOOTER //
// connector.bundle.js